import {
  IWebsiteBuilderSectionBase,
  IWebsiteBuilderSectionDataBase,
  TWebsiteBuilderSection,
} from "./websiteBuilderSection";

interface IWebsiteBuilderContentData extends IWebsiteBuilderSectionDataBase {
  type: "content";
}

export interface IWebsiteBuilderContent extends IWebsiteBuilderSectionBase {
  section: IWebsiteBuilderContentData;
}

export function isWebsiteBuilderContent(node: TWebsiteBuilderSection): node is IWebsiteBuilderContent {
  return node?.section?.type === "content";
}

export function generateDefaultContent(): IWebsiteBuilderContent {
  return {
    id: crypto.randomUUID(),
    type: "section",
    section: {
      type: "content",
      height: 200,
    },
    children: [],
  };
}
